import React, { useEffect, useState } from 'react';
import { Modal, Col, Row, Form, Spin, Button } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';

import { TechnicianContainer, ListTechnicianContainer, ButtonLink } from './styled';
import useTechniciansNear from './hooks/useTechniciansNear';
import { useDictionaryTranslation } from '../../../../hooks/useDictionaryTranslation';
import { GooglePlacesAutocomplete } from '../../../../components/geolocation/GooglePlacesAutocomplete';
import { ModalMap } from '../../../../components/modalMap/ModalMap';

export const ModalTechniciansNear = ({
  headquarter,
  specialities,
  address,
  technicianAssigned,
  show,
  handleClose,
  handleSelectTechnician
}) => {
  const { translate: t } = useDictionaryTranslation();
  const [form] = Form.useForm();
  const { getTechniciansNear, technicians, isLoading } = useTechniciansNear();
  const [technicianSelected, setTechnicianSelected] = useState(technicianAssigned);
  const [technicianInMap, setTechnicianInMap] = useState();
  const [isOpenMapModal, setIsOpenMapModal] = useState(false);

  const closeModal = () => {
    handleClose();
  };

  const getListTechniciansNear = async () => {
    if (headquarter && specialities && address?.markerCoords) {
      form.setFieldValue('address', address);
      const markerCoords = address?.markerCoords;
      getTechniciansNear({ headquarter, specialities, coordinates: [markerCoords?.longitude, markerCoords?.latitude], limit: 6 });
    }
  };

  const handleChangeAddress = async () => {
    const addressForm = form.getFieldValue('address');
    if (headquarter && specialities && addressForm?.markerCoords) {
      const markerCoords = addressForm?.markerCoords;
      getTechniciansNear({ headquarter, specialities, coordinates: [markerCoords?.longitude, markerCoords?.latitude], limit: 6 });
    }
  };

  const handleSeeLocation = async (technician) => {
    if (technician?.profile && technician?.profile?.position?.coordinates) {
      setTechnicianInMap({
        id: technician._id,
        coordinates: [technician?.profile?.position?.coordinates[0], technician?.profile?.position?.coordinates[1]],
      });
      setIsOpenMapModal(true);
    }
  };

  const onSubmit = async () => {
    handleSelectTechnician(technicianSelected);
  };

  useEffect(() => {
    getListTechniciansNear();
  }, [address, headquarter, specialities]
  );

  return (
    <Modal
      title={t('techniciansNear')}
      width="90%"
      height="70%"
      onCancel={closeModal}
      destroyOnClose
      open={show}
      footer={
        <div>
          <Button
            form={form}
            key="submit"
            htmlType="submit"
            type="primary"
            onClick={onSubmit}
            disabled={!technicianSelected || !technicianSelected._id}
          >
            {t('accept')}
          </Button>
        </div>
      }
    >
      <Spin spinning={isLoading}>
        <Form layout="vertical" form={form}>

          <Row>
            <Col xs={24} md={24}>
              <Form.Item
                name="address"
                label={t('address')}
              >
                <GooglePlacesAutocomplete onChange={handleChangeAddress} />
              </Form.Item>

              <ListTechnicianContainer>
                {
                  technicians.map((technician) => (
                    <TechnicianContainer key={technician._id} onClick={() => { setTechnicianSelected(technician) }}
                      style={{ background: technicianSelected?._id === technician?._id ? '#f0f0f0' : '#fff' }}>
                      <span style={{ fontSize: '12px' }}> <b>{technician.profile.name} - {technician.profile.identification}</b> </span>
                      <span style={{ fontSize: '12px' }}> ({(technician.distance).toFixed(3)} km) </span>
                      <span style={{ fontSize: '12px' }}> {t('lastReportedLocation')} </span>
                      <span style={{ fontSize: '12px' }}> {technician.profile?.positionDate ? moment(technician.profile?.positionDate).format('YYYY-MM-DD h:mm a') : ''} </span>
                      <ButtonLink type="link" onClick={(e) => { e.stopPropagation(); handleSeeLocation(technician) }}>
                        {t('seeLocation')}
                      </ButtonLink>
                    </TechnicianContainer>

                  ))
                }
              </ListTechnicianContainer>

            </Col>
          </Row>

        </Form>

        <ModalMap
          title={t('location')}
          show={isOpenMapModal}
          handleClose={() => setIsOpenMapModal(false)}
          userCoordinates={technicianInMap ? [technicianInMap] : []}
        />

      </Spin>
    </Modal>
  );
};

ModalTechniciansNear.propTypes = {
  headquarter: PropTypes.string,
  specialities: PropTypes.array,
  address: PropTypes.object,
  technicianAssigned: PropTypes.object,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSelectTechnician: PropTypes.func.isRequired,
};
